module.exports = __webpack_public_path__ + "img/123456.334181a8.png";